import { Box, Paper, Typography } from '@material-ui/core';
import EnvironmentBadge from '../../common/EnvironmentBadge';
import { useStyles } from '../../../../styles';
import './styles/projectContextHeader.css';

interface ProjectContextHeaderProps {
  projectName: string;
  environment: string;
  testPlanName: string;
}

export default function ProjectContextHeader({
  projectName,
  environment,
  testPlanName,
}: ProjectContextHeaderProps) {
  const classes = useStyles();
  return (
    <Paper className={classes.overwiewCards}>
      <Box className="ec-context-details">
        <Box className="ec-context-detail-item">
          <Typography component="span" className="ec-context-label">
            Project
          </Typography>
          <Typography component="span" className="ec-context-value">
            {projectName}
          </Typography>
        </Box>
        <Box className="ec-context-detail-item">
          <Typography component="span" className="ec-context-label">
            Environment
          </Typography>
          <EnvironmentBadge environment={environment} />
        </Box>
        <Box className="ec-context-detail-item">
          <Typography component="span" className="ec-context-label">
            Test Plan
          </Typography>
          <Typography component="span" className="ec-context-value">
            {testPlanName}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
